export enum Layout {
  Report,
  ReportSettings,
  Intermediate,
}
